// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-page-search-wrapper[data-v-4b27011b] {\n  margin-bottom: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
